module.exports = __webpack_public_path__ + "static/motto-e77128663ae1130984c58145a9e6d0d0.svg";